import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/auth-context';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminLayout } from './components/layout';

// Auth pages
import LoginPage from './pages/auth/LoginPage';

// Admin pages
import DashboardPage from './pages/admin/DashboardPage';
import ClientsPage from './pages/admin/clients/ClientsPage';
import ClientDetailPage from './pages/admin/clients/ClientDetailPage';
import ClientEditPage from './pages/admin/clients/ClientEditPage';
import ClientNewPage from './pages/admin/clients/ClientNewPage';
import TenantDetailPage from './pages/admin/tenants/TenantDetailPage';
import TenantEditPage from './pages/admin/tenants/TenantEditPage';
import PlansPage from './pages/admin/plans/PlansPage';
import PlanEditPage from './pages/admin/plans/PlanEditPage';
import PlanNewPage from './pages/admin/plans/PlanNewPage';
import FeaturesPage from './pages/admin/features/FeaturesPage';
import FeatureEditPage from './pages/admin/features/FeatureEditPage';
import FeatureNewPage from './pages/admin/features/FeatureNewPage';
import AdminsPage from './pages/admin/admins/AdminsPage';
import AdminEditPage from './pages/admin/admins/AdminEditPage';
import AdminNewPage from './pages/admin/admins/AdminNewPage';
import LanguagesPage from './pages/admin/languages/LanguagesPage';
import SettingsPage from './pages/admin/settings/SettingsPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Redirect root to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Protected admin routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <DashboardPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ClientsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients/new"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ClientNewPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients/:id"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ClientDetailPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients/:id/edit"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ClientEditPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/tenants/:slug"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <TenantDetailPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/tenants/:slug/edit"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <TenantEditPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/plans"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <PlansPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/plans/new"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <PlanNewPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/plans/:id/edit"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <PlanEditPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/features"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <FeaturesPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/features/new"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <FeatureNewPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/features/:id/edit"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <FeatureEditPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admins"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admins/new"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminNewPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admins/:id/edit"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminEditPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/languages"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <LanguagesPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <SettingsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
